angular
	.module 'App.Module.VatRate', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'vatrates',
				url: '/vatrates',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@vatrates":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'VatRateSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						repositoryName: 'VatRateRepository'
						title: 'general.vatrates'
						itemTemplate: '@app/vat-rate/vat-rate.search-result.view.html'
						filterEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.VatRateManagement.EnableVatRateSearch'
						createEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.VatRateManagement.EnableVatRateSearch'
					restrict: ['AND', 'Backoffice.TopMenu.VatRates', 'Shared.Setting.VatRate.Enabled']

			.state 'vatrates.edit',
				abstract: true,
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					vatRate: (VatRateRepository, $stateParams) ->
						query = VatRateRepository.createQuery()
						query.with 'price_region'

						return VatRateRepository.getEntity($stateParams.id, query)

			.state 'vatrates.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'VatRateController'
							controllerAs: 'vm'
							templateUrl: '@app/vat-rate/vat-rate.view.html'
